import { Directive, HostListener } from '@angular/core';

import * as screenfull from 'screenfull';

@Directive({
  selector: '[appToggleFullscreen]'
})
export class ToggleFullscreenDirective {

  @HostListener('click') onClick() {
    if (screenfull.enabled) {
      screenfull.toggle();
    }
  }
}



// WEBPACK FOOTER //
// E:/Git_new/IVMS_PRO/web/src/app/shared/fullscreen/toggle-fullscreen.directive.ts